import React from 'react';

const CalendarSearch = () => {
    return (
        <svg width="264" height="88" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fillRule="evenodd">
                <path
                    d="M156.889 7.1h-3.556V0h-7.11v7.1h-28.445V0h-7.111v7.1h-3.556c-3.947 0-7.075 3.195-7.075 7.1L100 63.9c0 3.905 3.164 7.1 7.111 7.1h49.778C160.8 71 164 67.805 164 63.9V14.2c0-3.905-3.2-7.1-7.111-7.1zM157 65h-50V29h50v36zm0-44h-50v-7h50v7z"
                    fill="#CCCFD0"
                />
                <path
                    fill="#D8D8D8"
                    fillRule="nonzero"
                    d="M111 34h9v7h-9zM111 43h9v7h-9zM111 52h9v7h-9zM122 34h9v7h-9zM122 43h9v7h-9zM122 52h9v7h-9zM133 34h9v7h-9zM133 43h9v7h-9zM133 52h9v7h-9zM144 34h9v7h-9zM144 43h9v7h-9zM144 52h9v7h-9z"
                />
                <g opacity=".448">
                    <path
                        d="M79 14h-2.5V9h-5v5h-20V9h-5v5H44c-2.775 0-4.975 2.25-4.975 5L39 54c0 2.75 2.225 5 5 5h35c2.75 0 5-2.25 5-5V19c0-2.75-2.25-5-5-5zm.078 40.775H43.922V29.423h35.156v25.352zm0-30.986H43.922v-4.93h35.156v4.93z"
                        fill="#CCCFD0"
                    />
                    <path
                        fill="#D8D8D8"
                        fillRule="nonzero"
                        d="M46 33h6v5h-6zM46 40h6v5h-6zM46 46h6v5h-6zM54 33h6v5h-6zM54 40h6v5h-6zM54 46h6v5h-6zM62 33h6v5h-6zM62 40h6v5h-6zM62 46h6v5h-6zM70 33h6v5h-6zM70 40h6v5h-6zM70 46h6v5h-6z"
                    />
                </g>
                <g opacity=".448">
                    <path
                        d="M20.444 24.5h-1.277V22H16.61v2.5H6.39V22H3.833v2.5H2.556C1.137 24.5.013 25.625.013 27L0 44.5C0 45.875 1.137 47 2.556 47h17.888C21.85 47 23 45.875 23 44.5V27c0-1.375-1.15-2.5-2.556-2.5zm.04 20.387H2.516V32.211h17.968v12.676zm0-15.493H2.516V26.93h17.968v2.464z"
                        fill="#CCCFD0"
                    />
                    <path
                        fill="#D8D8D8"
                        fillRule="nonzero"
                        d="M3.578 34h3.067v2.5H3.578zM3.578 37.5h3.067V40H3.578zM3.578 40.5h3.067V43H3.578zM7.667 34h3.067v2.5H7.667zM7.667 37.5h3.067V40H7.667zM7.667 40.5h3.067V43H7.667zM11.756 34h3.067v2.5h-3.067zM11.756 37.5h3.067V40h-3.067zM11.756 40.5h3.067V43h-3.067zM15.844 34h3.067v2.5h-3.067zM15.844 37.5h3.067V40h-3.067zM15.844 40.5h3.067V43h-3.067z"
                    />
                </g>
                <g opacity=".448">
                    <path
                        d="M261.444 24.5h-1.277V22h-2.556v2.5H247.39V22h-2.556v2.5h-1.277c-1.419 0-2.543 1.125-2.543 2.5L241 44.5c0 1.375 1.137 2.5 2.556 2.5h17.888c1.406 0 2.556-1.125 2.556-2.5V27c0-1.375-1.15-2.5-2.556-2.5zm.04 20.387h-17.968V32.211h17.968v12.676zm0-15.493h-17.968V26.93h17.968v2.464z"
                        fill="#CCCFD0"
                    />
                    <path
                        fill="#D8D8D8"
                        fillRule="nonzero"
                        d="M244.578 34h3.067v2.5h-3.067zM244.578 37.5h3.067V40h-3.067zM244.578 40.5h3.067V43h-3.067zM248.667 34h3.067v2.5h-3.067zM248.667 37.5h3.067V40h-3.067zM248.667 40.5h3.067V43h-3.067zM252.756 34h3.067v2.5h-3.067zM252.756 37.5h3.067V40h-3.067zM252.756 40.5h3.067V43h-3.067zM256.844 34h3.067v2.5h-3.067zM256.844 37.5h3.067V40h-3.067zM256.844 40.5h3.067V43h-3.067z"
                    />
                </g>
                <g opacity=".448">
                    <path
                        d="M220 14h-2.5V9h-5v5h-20V9h-5v5H185c-2.775 0-4.975 2.25-4.975 5L180 54c0 2.75 2.225 5 5 5h35c2.75 0 5-2.25 5-5V19c0-2.75-2.25-5-5-5zm.078 40.775h-35.156V29.423h35.156v25.352zm0-30.986h-35.156v-4.93h35.156v4.93z"
                        fill="#CCCFD0"
                    />
                    <path
                        fill="#D8D8D8"
                        fillRule="nonzero"
                        d="M187 33h6v5h-6zM187 40h6v5h-6zM187 46h6v5h-6zM195 33h6v5h-6zM195 40h6v5h-6zM195 46h6v5h-6zM203 33h6v5h-6zM203 40h6v5h-6zM203 46h6v5h-6zM211 33h6v5h-6zM211 40h6v5h-6zM211 46h6v5h-6z"
                    />
                </g>
                <path
                    d="M169.275 72.78L181 84.505 177.505 88 165.78 76.275a18.456 18.456 0 01-11.243 3.798c-10.238 0-18.537-8.299-18.537-18.536C136 51.299 144.3 43 154.537 43c10.237 0 18.536 8.3 18.536 18.537 0 4.227-1.415 8.125-3.798 11.243zm-14.738 2.35c7.507 0 13.593-6.086 13.593-13.593 0-7.508-6.086-13.594-13.593-13.594-7.508 0-13.594 6.086-13.594 13.594 0 7.507 6.086 13.593 13.594 13.593z"
                    fill="#4C595B"
                />
            </g>
        </svg>
    );
};

export default CalendarSearch;
